import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import DefaultImg from "../../images/defaultImg.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { backendApi, re, emailValidation, phNum } from "../../api/apiService";
import { FaSearch } from "react-icons/fa";

// import { FaHome } from "react-icons/fa";

function AdminSettings() {
  const [addPeoplePopup, setAddPeoplePopup] = useState(false);
  const [memberName, setMemberName] = useState("");
  const [email, setEmail] = useState("");
  const [users, setUsers] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState({});

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("UserRolesMenu")?.classList?.add("active");
    }, 500);
    getUsers();
  }, []);

  const getUsers = () => {
    var req = {
      functionName: "userListForRoleChange",
      sec_user_id: localStorage.getItem("userId"),
      site_id: localStorage.getItem("siteId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log(response);
      if (response.success == 1) {
        setUsers(response.dataSet);
        setRoleData(response.roleData);
      } else {
        console.log("Error inviting user.");
        return false;
      }
    });
  };

  const Cancel = () => {
    // $("#addPeople").hide();
    setAddPeoplePopup(false);
    setMemberName("");
    setEmail("");
  };

  const handleRoleChange = (userId, roleId) => {
    var req = {
      functionName: "updateUserRole",
      sec_user_id: userId,
      site_id: localStorage.getItem("siteId"),
      role_id: roleId,
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log(response);
      if (response.success == 1) {
        toast.success("User role changed succesfully", { containerId: "F" });
      } else {
        console.log("Error inviting user.");
        return false;
      }
    });
  };

  const Invite = () => {
    if (email.trim() === "") {
      toast.warn("Please enter an email:", { containerId: "F" });
      return false;
    } else if (!re.test(email)) {
      toast.warn("Enter Valid Organization Email-Id please", {
        containerId: "F",
      });
      return false;
    } else if (!email.match(emailValidation)) {
      toast.warn("Kindly enter a valid email-Id", { containerId: "F" });
      return false;
    } else if (memberName === "") {
      toast.warn("Kindly enter a name", { containerId: "F" });
      return false;
    }
    const names = memberName.split(" ");
    if (names.length >= 2) {
      var req = {
        functionName: "inviteMember",
        site_id: localStorage.getItem("siteId"),
        first_name: names[0],
        last_name: names.slice(1).join(" "),
        email_id: email,
      };
      console.log("invitereq", req);
      backendApi(req).then((response) => {
        console.log(response);
        if (response.success == 1) {
          toast.success("User invited successsfully", { containerId: "F" });
          setAddPeoplePopup(false);
          setMemberName("");
          setEmail("");
          getUsers();
        } else {
          toast.warn("Error inviting user.", { containerId: "F" });
          return false;
        }
      });
    } else {
      toast.warn(
        "Invalid name format. Please provide both first name and last name.",
        { containerId: "F" }
      );
      return false;
    }
  };
  const [menuClick, setMenuClick] = useState(false)
  const toggleMenu = () => {
    setMenuClick(!menuClick)
  }
  const closeMenu = () => {
    setMenuClick(false)
  }
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"F"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
       <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header Header="User Roles" toggleMenu={toggleMenu} menuClick={menuClick} />
          <div className="main-container">
            <div className="xilliRight">
              <div className="xilliWrap">
                
                <div className="card main-card">
                  <div className="card-body">
                    
                <div className="col-md-12">
                  <div className="xilliWrap  table-wrap">
                    <div className="row">
                      <div className="col-md-8 m-auto">
                      <div class="text-end mb-3">
                      <button
                              className="btn-btn btn btn-btn2 btn-sm ml-auto"
                              onClick={() => setAddPeoplePopup(true)}
                            >
                              Add New User
                            </button>
                        </div>
                        <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Sl.No</th>
                              <th>Name</th>
                              <th>Role</th>
                            </tr>
                          </thead>
                          <tbody>
                            {users.map((user, index) => (
                              <tr>
                                <td aria-label="Sl.No">{index + 1}</td>
                                <td aria-label="Title">
                                  {user.first_name + " " + user.last_name}
                                </td>
                                <td aria-label="Role">
                                  <select className="form-control"
                                    defaultValue={user.role_id}
                                    value={selectedRoles[user.id]}
                                    onChange={(e) =>
                                      handleRoleChange(user.id, e.target.value)
                                    }
                                  >
                                    {roleData.map((role) => (
                                      <option key={role.id} value={role.id}>
                                        {role.role_name}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>  
                </div>            
                </div>
              </div>
            </div>
          </div>
          {addPeoplePopup && (
        <div className="modal_parent">
          <div className="module_popup addPeople bfAddPeople">
            <div className="module_innerpopup module_bodypop">
              <div className="module_headdiv">
                <h4 className="popup_head mb-2">Invite People</h4>
              </div>
              <div className="module_body" style={{ overflowX: "hidden" }}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-group input-group-outline mb-2 location_search">
                      <label htmlFor="" className="form-label">
                        Name
                      </label>
                      <div className="col-md-12 p-0 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Name..."
                          value={memberName}
                          onChange={(e) => setMemberName(e.target.value)}
                        />
                      </div>
                    </div>{" "}
                  </div>
                  <div className="col-md-6">
                    <div className="input-group input-group-outline mb-2 location_search">
                      <label htmlFor="" className="form-label">
                        Email Id
                      </label>
                      <div className="col-md-12 p-0 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Email Id..."
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>

              <div className="childIssueses my-2">
                <button className="btn-btn btn btn-btn2 btn-sm me-2" onClick={Invite}>
                  Invite
                </button>
                <button
                  className="btn-btn btn btn-btn1 btn-sm"
                  onClick={() => {
                    Cancel();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
        </div>
      </div>
    </>
  );
}
export default AdminSettings;
